
document.addEventListener("DOMContentLoaded", function () {
  var colorLabels = document.querySelectorAll("[variant-input][name='Color']+[variant-label]");
  var vsNameElement = document.querySelector('[vs__name]');
  var checkedInput = document.querySelector("[variant-input]:checked");
  if (vsNameElement && checkedInput) {
    vsNameElement.textContent = checkedInput.value;
  }
  colorLabels.forEach(function (label) {
    label.addEventListener("click", function () {
      var selectedVariant = this.getAttribute("data-value");
      var allMediaItems = document.querySelectorAll("[product__media-list] [produt-img]");
      var allLookBookItems = document.querySelectorAll("[custom-product-lookbook] [produt-img]");
      var allMediaItemsthumbnails = document.querySelectorAll(".thumbnail-list img");
      allLookBookItems.forEach(function (lookimg) {
        lookimg.style.display = 'none';
      });
      allMediaItems.forEach(function (img) {
        img.closest('[product__media-item]').style.display = 'none';
      });
      var selectedLookBookItems = document.querySelectorAll("[custom-product-lookbook] [produt-img][alt*='color_" + selectedVariant + "']");
      selectedLookBookItems.forEach(function (lookimg) {
        lookimg.style.display = 'block';
      });
      var selectedMediaItems = document.querySelectorAll("[product__media-list] [produt-img][alt*='color_" + selectedVariant + "']");
      selectedMediaItems.forEach(function (img) {
        img.closest('[product__media-item]').style.display = 'block';
      });
      allMediaItemsthumbnails.forEach(function (thumimg) {
        thumimg.closest('[thumbnail-list__item]').style.display = 'none';
      });
      var selectedMediaItemsthumb = document.querySelectorAll(".thumbnail-list img[alt*='color_" + selectedVariant + "']");
      selectedMediaItemsthumb.forEach(function (thumimg) {
        thumimg.closest('[thumbnail-list__item]').style.display = 'block';
      });
      var vsNameElement = document.querySelector('[vs__name]');
      selectedVariant = selectedVariant.charAt(0).toUpperCase() + selectedVariant.slice(1);
      vsNameElement.textContent = selectedVariant;
    });
  });
  function galleryImage() {
    var checkedInputx = document.querySelector("[variant-input]:checked+[variant-label]");
    var selectedVariantx = checkedInputx.getAttribute('data-value');
    var allMediaItemsx = document.querySelectorAll("[product__media-list] [produt-img]");
    var allLookBookItemsx = document.querySelectorAll("[custom-product-lookbook] [produt-img]");
    var allMediaItemsthumbnailsx = document.querySelectorAll(".thumbnail-list img");
    allMediaItemsx.forEach(function (img) {
      img.closest('[product__media-item]').style.display = 'none';
    });
    allLookBookItemsx.forEach(function (lookimg) {
      lookimg.style.display = 'none';
    });
    var selectedLookBookItemsx = document.querySelectorAll("[custom-product-lookbook] [produt-img][alt*='color_" + selectedVariantx + "']");
    selectedLookBookItemsx.forEach(function (lookimg) {
      lookimg.style.display = 'block';
    });
    var selectedMediaItemsx = document.querySelectorAll("[product__media-list] [produt-img][alt*='color_" + selectedVariantx + "']");
    selectedMediaItemsx.forEach(function (img) {
      img.closest('[product__media-item]').style.display = 'block';
    });
    allMediaItemsthumbnailsx.forEach(function (thumimgx) {
      thumimgx.closest('[thumbnail-list__item]').style.display = 'none';
    });
    var selectedMediaItemsthumbx = document.querySelectorAll(".thumbnail-list img[alt*='color_" + selectedVariantx + "']");
    selectedMediaItemsthumbx.forEach(function (thumimgx) {
      thumimgx.closest('[thumbnail-list__item]').style.display = 'block';
    });
  }
  setTimeout(() => {
    galleryImage();
    console.log('success');
  }, 100);
});
function countAndDisplaySnaps() {
  const liElements = document.querySelectorAll('[product__media-item]');
  let totalSnaps = 0;
  liElements.forEach((li) => {
    if (li.style.display !== 'none') {
      totalSnaps++;
    }
  });
  let mobileDots = document.querySelector('[cstmMobileDots]');
  mobileDots.innerHTML = '';
  for (var i = 1; i <= totalSnaps; i++) {
    let divDots = document.createElement("div");
    divDots.classList.add("boxCstmDots");
    divDots.setAttribute("divNumber", i);
    mobileDots.appendChild(divDots);
    if (i === 1) {
      divDots.classList.add("active");
    }
  }
  let changenumber = document.querySelector('[slider-counter--current]');
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target === changenumber && mutation.type === 'childList') {
        let changednumber = changenumber.innerHTML;
        let customdots = document.querySelectorAll('.boxCstmDots');
        for (var i = 0; i < customdots.length; i++) {
          let customdotsIndex = customdots[i].getAttribute('divNumber');
          if (changednumber == customdotsIndex) {
            customdots[i].classList.add('active');
          } else {
            customdots[i].classList.remove('active');
          }
        }
      }
    });
  });
  let observerConfig = { childList: true, characterData: true, subtree: true };
  observer.observe(changenumber, observerConfig);
}
function updateTotalSnaps() {
  let dynamicValue = getDynamicValue();
  let totalSnaps = dynamicValue;
  countAndDisplaySnaps();
}
function getDynamicValue() {
  return Math.floor(Math.random() * 10) + 1;
}
updateTotalSnaps();
setTimeout(updateTotalSnaps, 700);
document.addEventListener('variant:changed', () => {
  updateTotalSnaps();
});

document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll('[accordion-tab]');
  accordionItems.forEach(function (item) {
    item.addEventListener('click', function () {
      accordionItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          otherItem.removeAttribute('open-accordion');
        }
      });
      if (item.hasAttribute('open-accordion')) {
        item.removeAttribute('open-accordion');
      } else {
        item.setAttribute('open-accordion', 'true');
      }
    });
  });
});